// NgRx
import { createSelector } from '@ngrx/store';
const getNotesState = (state) => {
    return state;
};
export const getSelectedNote = (state) => {
    return state.selectedNote;
};
const getSelectedNoteSharingStatus = createSelector(getSelectedNote, (selectedNote) => {
    if (selectedNote)
        return selectedNote.sharing;
    return undefined;
});
export const getNotesItems = createSelector(getNotesState, (notesState) => notesState.notesItems);
export const getNotesStateFetchRequest = createSelector(getNotesState, (notesState) => notesState.fetchRequest);
export const getSelectedNoteId = createSelector(getSelectedNote, (selectedNote) => {
    if (selectedNote)
        return selectedNote.id;
    return undefined;
});
export const getSelectedNoteIsDeletable = createSelector(getSelectedNoteSharingStatus, (sharingStatus) => sharingStatus !== undefined && sharingStatus.is_owner);
export const getSelectedNoteIsShareable = createSelector(getSelectedNoteSharingStatus, (sharingStatus) => {
    return sharingStatus !== undefined && sharingStatus.is_owner;
});
export const getSelectedNoteText = createSelector(getSelectedNote, (selectedNote) => {
    if (selectedNote)
        return selectedNote.content;
    return undefined;
});
